export default __webpack_public_path__ + "static/sea-59aef973751006f90ebb00fb7c38c67c.gif";